import New from "csi/table/New";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";
import Relationship from "csi/def/Relationship";
import csiStore from "csi/store/_base";
import Action from "csi/def/Action";
import ViewRef from "csi/def/ViewRef";
import StoreNamesConstructor, { StoreNames } from "csi/store/Names";
/** @property {string} FOOD_INGREDIENT - the node type used in the controller */
const FOOD_INGREDIENT = "FoodIngredient";
const NewFoodIngredientImpactAnalysis= declare(New, {
	/**
	 * @override
	 * Allow controller to add parameters to popup view
	 */
	onCreatePopupParams(params) {
		params.productLabel = FOOD_INGREDIENT;
		params.productStore = this._getFoodIngredientStore();
	},
	/**
	 * Fetch list of all FoodIngredients
	 */
	_getFoodIngredientStore(): StoreNames {
		const rel = lang.mixin(new Relationship(), {
			m_typeNode: FOOD_INGREDIENT,
		});
		const storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), rel);
		storeOptions.data = [csiStore.nameObject("")];
		storeOptions.action = lang.mixin(new Action(), {
			m_viewRef: lang.mixin(new ViewRef(), {
				m_id: "FoodIngredients",
				m_url: "centric://REFLECTION/INSTANCE/_CS_Data/null",
			}),
		});
		return new StoreNamesConstructor(storeOptions);
	},
	/**
	* @override
	* On FoodIngredient node, make the FoodIngredient as default & selected on engineering change form
	*/
	onCreatePopup(view) {
		view.addFixedValue(FOOD_INGREDIENT, this.m_urlParent);
		this.inherited(arguments);
	},
	/**
	 * @override
	 * FoodIngredient is marked to be taken care on the server side
	 */
	toWriterRequest(fd: FormData): CallMethod {
		const call = this.inherited<CallMethod>(arguments);
		const FoodIngredientURLs = this.m_formData.getFieldValue(FOOD_INGREDIENT, true);
		call.addParameter("AddURLs", xml.ATTR_REFLIST, FoodIngredientURLs);
		call.addParameter("Purpose", xml.ATTR_ENUM, "ECPurpose:ImpactAnalysis");
		return call;
	},
});
export = NewFoodIngredientImpactAnalysis;